export default {
  simplePlaceSearch: {
    noPlaceFound: 'Kein Ort mit diesen Angaben gefunden',
    openSidebarToSeeRouteDetails: 'Öffnen Sie die Seitenleiste, um Routendetails zu sehen.',
    unknownSearchPlaceError: 'Unbekannter Fehler beim Suchen von Orten'
  }
}
